import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule, MarkedOptions, MarkedRenderer } from 'ngx-markdown';

// a list of support tags to persits during html -> markdown conversion
export const supportedMarkdownHTMLTags = ['strong', 'sub', 'sup'];

export function getDefaultMarkdownOptions(): MarkedOptions {
  const renderer = new MarkedRenderer();

  // links will always open in a new window + link validation
  renderer.link = (href: string, title: string, text: string) => {
    const sanitizedHref = sanitizeURL(href);
    return `<a href="${sanitizedHref}" target="_blank" rel="noreferrer nofollow">${text}</a>`;
  };

  // fix trailing newline created by markedjs
  renderer.paragraph = (text: string) => {
    return `<p>${text}</p>`;
  };

  // disable images
  renderer.image = (href: string, title: string, text: string) => {
    return '';
  };

  return {
    renderer: renderer, // special overrides for custom output
    gfm: false // GitHub Flavored Markdown: disable, basic Markdown support
  };
}

// sanitize malformed/malicious URLs
function sanitizeURL(url: string): string {
  if (url.match(/^(?:(?:(?:ht)tps?):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i)) {
    return url;
  } else {
    return '';
  }
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // Markdown Support
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useFactory: getDefaultMarkdownOptions
      }
    })
  ]
})
export class MarkdownConfigModule { }
